import { render, staticRenderFns } from "./CustomQueryShow.vue?vue&type=template&id=2b8ce436&scoped=true&"
import script from "./CustomQueryShow.vue?vue&type=script&lang=js&"
export * from "./CustomQueryShow.vue?vue&type=script&lang=js&"
import style0 from "./CustomQueryShow.vue?vue&type=style&index=0&id=2b8ce436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ce436",
  null
  
)

export default component.exports